import "./App.css";
import Home from "./pages/Home";
import WhatWeRun from "./pages/WhatWeRun";
import Projects from "./pages/Projects";
import Brief from "./pages/Brief";
import { Route, Routes } from "react-router-dom";

function App() {
  return (
    <div className="App w-full min-h-screen">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/what-we-run" element={<WhatWeRun />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/brief" element={<Brief />} />
      </Routes>
    </div>
  );
}

export default App;
